export const getPoolList = (state) => state.AISDataProvider.poolList;
